<template>
  <div>
    <b-card>
      <b-row>
        <!-- User Info: Left col -->
        <b-col
          cols="21"
          xl="6"
          class="d-flex justify-content-between flex-column"
        >
          <!-- User Avatar & Action Buttons -->
          <div class="d-flex justify-content-start">
            <b-avatar
              variant="light-primary"
              size="104px"
              rounded
            >
              <feather-icon
                icon="ListIcon"
                size="70"
              />
            </b-avatar>
            <div class="d-flex flex-column ml-1">
              <div class="mb-1">
                <h4 class="mb-0">
                  {{ viewJobTemplateData.alias }}
                </h4>
                <span class="card-text">{{ viewJobTemplateData.id }}</span>
              </div>
              <div class="d-flex flex-wrap">
                <b-dropdown
                  id="dropdown-1"
                  variant="outline-primary"
                >
                  <template #button-content>
                    <b-spinner
                      v-if="isLoading"
                      small
                      class="mr-50"
                    />
                    <span>Actions</span>
                  </template>
                  <b-dropdown-item
                    :to="{ name: 'job-templates-edit', params: { id: viewJobTemplateData.id } }"
                    :disabled="viewJobTemplateData.jobCount > 0"
                  >
                    <feather-icon
                      icon="Edit2Icon"
                      class="mr-50"
                    />
                    <span>Edit</span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    variant="text-danger"
                    :disabled="viewJobTemplateData.jobCount > 0"
                    @click="deleteJobTemplate"
                  >
                    <span class="text-danger">
                      <feather-icon
                        icon="Trash2Icon"
                        class="mr-50"
                      />
                      <span>Delete</span>
                    </span>
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
          </div>
        </b-col>

        <!-- Right Col: Table -->
        <b-col
          cols="12"
          xl="6"
        >
          <table class="mt-2 mt-xl-0 w-100">
            <tr>
              <th class="pb-50">
                <feather-icon
                  icon="CheckIcon"
                  class="mr-75"
                />
                <span class="font-weight-bold">Number of steps</span>
              </th>
              <td class="pb-50 text-capitalize">
                {{ viewJobTemplateData.jobItemCount }} steps
              </td>
            </tr>
            <tr>
              <th class="pb-50">
                <feather-icon
                  icon="ClipboardIcon"
                  class="mr-75"
                />
                <span class="font-weight-bold">Jobs using this template</span>
              </th>
              <td class="pb-50">
                {{ viewJobTemplateData.jobCount }} Jobs
              </td>
            </tr>
          </table>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col>
          <b-card-text>
            <b-row
              align-h="end"
              class="text-muted w-100 mt-2 mx-0"
            >
              <b-col
                class="text-right"
              >
                <feather-icon
                  icon="ClockIcon"
                  class="mr-75"
                />
                <span class="font-weight-bold">Added: {{ toHumanDate(viewJobTemplateData.createdAt) }}</span>
              </b-col>
            </b-row>
          </b-card-text>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BButton,
  BAvatar,
  BRow,
  BCol,
  BCardText,
  BSpinner,
  BDropdown,
  BDropdownItem,
  VBModal,

} from 'bootstrap-vue'
import toHumanDate from '@/libs/utils/general/dates'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'

export default {
  directives: {
    Ripple,
    'b-modal': VBModal,
  },
  components: {
    BCard,
    BCardText,
    BRow,
    BCol,
    BAvatar,
    BSpinner,
    BDropdown,
    BDropdownItem,
  },
  props: {
    jobTemplateData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      viewJobTemplateData: this.$props.jobTemplateData,
      isLoading: false,
      inactiveVehicleCheckbox: false,
    }
  },
  setup() {
    return {
      toHumanDate,
    }
  },
  methods: {
    deleteJobTemplate() {
      this.isLoading = true
      store.dispatch('app-job-template/deleteJobTemplate', { id: this.viewJobTemplateData.id })
        .then(response => {
          this.$router.push({ name: 'job-templates-list' })
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Job Template removed',
              icon: 'CheckSquareIcon',
              variant: 'success',
              text: 'You have successfully removed a job template.',
            },
          })
          this.isLoading = false
        })
        .catch(err => {
          Object.entries(err.response.data.errors).forEach(errors => {
            const field = errors[0]
            const messages = errors[1]
            const toUppercase = str => str.toUpperCase()
            messages.forEach(errorMessage => {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: `${field.replace(/[A-Z]/g, ' $&').replace(/^./, toUppercase)}`,
                  icon: 'XIcon',
                  variant: 'warning',
                  text: errorMessage,
                },
              })
            })
          })

          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Job template update failed',
              icon: 'XIcon',
              variant: 'danger',
              text: err.response.data.message || 'An error occurred while removing this job template.',
            },
          })
          this.isLoading = false
        })
    },
  },
}
</script>

<style>

</style>
